import {Component, OnInit} from '@angular/core';
import { ChatgptService } from '../../gptService';
import { ApiService } from '../../api.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-chat',
  templateUrl: './gpt.component.html',
  styleUrls: ['./gpt.component.css']
})
export class GptComponent implements OnInit{
  userInput = '';
  messages: any[] = [];
  isLoading = false;
  isFirst = true;
  isConfigurationActive = false;
  assistantConfiguration: any;
  fileObject = {
    nomeFile: '', url: ''
  };
  isFileSet = false;
  fileInputType = 'file';
  fileInputId = 'file-upload';
  uploadedFiles: File[] = [];
  chatFilesToAdd = { url_documentazione: [] };
  constructor(public apiService: ApiService, private chatgptService: ChatgptService, private snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.chatgptService.getSettings().subscribe(result => {
     this.assistantConfiguration = result;
     this.assistantConfiguration.openai_api_key = this.chatgptService.apiKey;
     if (this.assistantConfiguration.url_documentazione.length > 0 && this.assistantConfiguration.url_documentazione[0].url !== '' && this.assistantConfiguration.url_documentazione[0].url !== null){
       this.isFileSet = true;
     }else{
       this.assistantConfiguration.url_documentazione = [];
     }
    });
  }

  onFileSelected(event: any): void  {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const base64String = e.target.result as string;
        const base64Data = base64String.split(',')[1]; // Splitting and taking the part after the comma

        this.assistantConfiguration.url_documentazione.push({
          url: base64Data,
          nomeFile: file.name
        });
      };
      reader.readAsDataURL(file);
    }
  }
  downloadFile(file: any): void {
    const link = document.createElement('a');

    // Determine the MIME type from the file extension
    const mimeType = this.getMimeType(file.nomeFile);

    // Construct the full base64 URL including the MIME type
    const base64Url = `data:${mimeType};base64,${file.url}`;

    link.href = base64Url;
    link.download = file.nomeFile;
    link.click();
  }
  private getMimeType(fileName: string): string {
    // Extract the file extension
    const extension = fileName.split('.').pop()?.toLowerCase();

    // Map common file extensions to MIME types
    // Add more cases as per your requirements
    switch (extension) {
      case 'pdf':
        return 'application/pdf';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      case 'txt':
        return 'text/plain';
      // Add more cases for other file types
      default:
        return 'application/octet-stream'; // Default binary type
    }
  }
  deleteFile(file: any): void {
    this.assistantConfiguration.url_documentazione = this.assistantConfiguration.url_documentazione.filter(f => f !== file);
  }
  addFileConfiguration(): void{
    this.assistantConfiguration.url_documentazione.push(this.fileObject);
  }

  updateSettings(): void{
    console.log(this.assistantConfiguration);
    this.chatgptService.updateSettings(this.assistantConfiguration).subscribe(result => {
      this.isConfigurationActive = false;
      this.snackBar.open('Configurazione aggiornata correttamente', null, {
        duration: 4000,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['mat-toolbar', 'custom-success-bg']
      });
    }, errorLog => {
      this.snackBar.open('Errore aggiornamento configurazione', null, {
        duration: 3000,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['mat-toolbar', 'custom-danger-bg']
      });
    });
  }



  async sendMessage(): Promise<void> {
    let userMessage = this.userInput.trim();
    if (userMessage && !this.isLoading) {
      this.isLoading = true;
      await this.processUploadedFiles();  // Process files before sending message

      this.addToChat(userMessage, 'user');
      if (this.isFirst) {
        this.isFirst = false;
      }

      this.chatgptService.getResponse(userMessage, this.chatFilesToAdd).subscribe(
        (response: any) => {
          let formattedMessage = this.formatMessage(response.message);
          this.addToChat(formattedMessage, 'bot');
          this.isLoading = false;
        },
        (error) => {
          console.error('Error:', error);
          this.isLoading = false;
        }
      );
      this.userInput = '';
    }
  }
// Function to process files and add them to chatFilesToAdd
  async processUploadedFiles(): Promise<void> {
    this.chatFilesToAdd.url_documentazione = [];
    for (const file of this.uploadedFiles) {
      const base64Data = await this.fileToBase64(file);
      this.chatFilesToAdd.url_documentazione.push({
        url: base64Data.split(',')[1],
        nomeFile: file.name
      });
    }
  }

// Helper function to convert a file to base64
  private fileToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }
  private addToChat(message: string, senderText: string): void {
    let fileLinks = '';
    if (this.uploadedFiles.length > 0) {
      fileLinks = this.uploadedFiles.map(file =>
        `<div class="menu-item">
          <b><u>File caricato correttamente: </u></b>
          <span class="file-name">${file.name}</span><br>
          ----------------------
        </div>`
      ).join('');
    }

    this.messages.push({ content: fileLinks + message, sender: senderText });
    this.uploadedFiles = []; // Clear the uploaded files after adding to chat
  }
  handleFileInput(event: any): void {
    const files = event.target.files;
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        this.uploadedFiles.push(files[i]);
      }
    }
  }

  removeFile(index: number): void {
    if (index > -1) {
      this.uploadedFiles.splice(index, 1);
    }
  }

  uploadFile(file: File): void {
    // Your file upload logic here
    // Example:
    // const formData = new FormData();
    // formData.append('file', file, file.name);
    // this.apiService.uploadFile(formData).subscribe(response => {
    //   console.log('File uploaded successfully', response);
    // }, error => {
    //   console.error('File upload failed', error);
    // });
  }
  formatChatGPTMessage(message: string): string {
    // Handle code blocks before other replacements to avoid interfering with them
    message = this.formatCodeMessages(message);

    // Handle images
    message = message.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1">');

    // Handle links
    message = message.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');

    // Handle horizontal rules
    message = message.replace(/---/g, '<hr>');

    // Handle blockquotes
    message = message.replace(/<br>> ([^<]+)/g, '<blockquote>$1</blockquote><br>');

    // Handle lists
    message = message
      .replace(/<br>\d+\./g, '<br><ol><li>')
      .replace(/<br>- /g, '<br><ul><li>')
      .replace(/<\/li><br>/g, '</li>')
      .replace(/<\/ul><br>/g, '</ul>')
      .replace(/<\/ol><br>/g, '</ol>');

    // Handle inline code
    message = message.replace(/`([^`]+)`/g, '<code>$1</code>');

    // Handle bold and italic text
    message = message
      .replace(/\*\*\*([^*]+)\*\*\*/g, '<strong><em>$1</em></strong>') // Bold and Italic
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>') // Bold
      .replace(/\*([^*]+)\*/g, '<em>$1</em>'); // Italic

    // Handle strikethrough text
    message = message.replace(/~~([^~]+)~~/g, '<del>$1</del>');

    // Handle headings
    message = message
      .replace(/###### ([^\n<]+)/g, '<h6>$1</h6>')
      .replace(/##### ([^\n<]+)/g, '<h5>$1</h5>')
      .replace(/#### ([^\n<]+)/g, '<h4>$1</h4>')
      .replace(/### ([^\n<]+)/g, '<h3>$1</h3>')
      .replace(/## ([^\n<]+)/g, '<h2>$1</h2>')
      .replace(/# ([^\n<]+)/g, '<h1>$1</h1>');

    // Add bold to step numbers and break lines
    message = message.replace(/(?<!^)(\d+\. )/g, '<br><strong>$1</strong>');

    // Convert newlines to <br>
    message = message.replace(/\n/g, '<br>');

    return message;
  }


  private formatCodeMessages(message: string): string {
    const codeRegex = /```([a-z]*)\n([\s\S]*?)```/g;
    return message.replace(codeRegex, (match, lang, code) => {
      return `<pre><code class="language-${lang}">${this.escapeHtml(code)}</code></pre>`;
    });
  }

  private escapeHtml(code: string): string {
    return code
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

// Add this function to combine all formatting
  private formatMessage(message: string): string {
    return this.formatChatGPTMessage(message);
  }
}
